import { z } from 'zod';

export const socialCardSchema = z.object({
	locale: z.string().optional(), // Optional for flexibility (some cards might not have this field)
	publisher: z.string().optional(), // Specific to FacebookCard
	type: z.string(), // e.g., "FacebookCard" or "TwitterCard"
	card: z.string(), // e.g., "Article", "summary_large_image"
	title: z.string(),
	description: z.string(),
	url: z.string().optional(),
	image: z.string().url(), // Ensures the value is a valid URL
	site: z.string().optional(), // Used for both TwitterCard and FacebookCard
	creator: z.string().optional(), // Specific to TwitterCard
	domain: z.string().optional(), // Specific to TwitterCard
});